export const SET_LOGIN_TYPE = "SET_LOGIN_TYPE";

export const setLoginType = (type) => ({
  type: SET_LOGIN_TYPE,
  payload: type,
});
